export const getPassengersAndRoomFromQuery = (parameterPassengers: string) => {
  const rooms = parameterPassengers?.split("_");
  let passengers: Array<{ adultCount: number; children: Array<number> }> = [
    {
      adultCount: 2,
      children: []
    }
  ];
  if (rooms) {
    passengers = rooms.map((room) => {
      const ages = room.split(",").map(Number);
      return {
        adultCount: ages.shift() || 1,
        children: ages
      };
    });
  }
  const adults = passengers?.reduce(
    (previousCount, room) => previousCount + room.adultCount,
    0
  );
  const child = passengers?.reduce(
    (previousCount, room) => previousCount + (room.children?.length || 0),
    0
  );
  return { passengers, rooms, adults, child };
};

export const getPassengersCountAboveTwoYearsOld = (
  parameterPassengers: string
) => {
  const { passengers, adults } =
    getPassengersAndRoomFromQuery(parameterPassengers);
  const childrenCount = passengers?.reduce((previousCount, room) => {
    const childrenAboveAgeTwo = room.children?.filter(
      (childAge) => childAge > 2
    );
    return previousCount + (childrenAboveAgeTwo?.length || 0);
  }, 0);
  return adults + childrenCount;
};
